<template>
  <div :class="classes()">
    <Icon :name="iconName" color="primaryBlue" :class="`${el}__icon`" />
    <div :class="`${el}__content`">
      <Headline v-if="$matchMedia.l" size="xs" noMargin>{{ headline }}</Headline>
      <Copy v-else element="div" color="primaryBlue" size="l" bold>{{ headline }}</Copy>

      <Copy v-if="subline" element="div" :staticClass="`${el}__subline`" color="tertiaryLight">
        {{ subline }}
      </Copy>
    </div>
    <Button
      :class="`${el}__button`"
      :label="button.label"
      :additionalIconName="button.iconName"
      :loading="button.loading"
      additionalIconPos="left"
      @click="$emit('click')"
      small
    />
  </div>
</template>

<script>
import Headline from '@/objects/Headline';
import Copy from '@/objects/Copy';
import Icon from '@/objects/Icon';
import Button from '@/objects/Button';
import { IconNameTypes } from '@/constants/enums';

export default {
  name: 'ActionBar',
  props: {
    headline: {
      type: String,
      required: true,
    },
    subline: {
      type: String,
    },
    iconName: {
      type: String,
      required: true,
      validator: (val) => IconNameTypes.includes(val),
    },
    button: {
      required: true,
      loading: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
        required: true,
      },
      iconName: {
        type: String,
        validator: (val) => IconNameTypes.includes(val),
      },
    },
  },
  components: {
    Headline,
    Copy,
    Icon,
    Button,
  },
  data() {
    return {
      el: 'c-actionBar',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
};
</script>
